var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import styled from 'styled-components';
import { Colors } from '@brg/ui';
import ColoredPost from '../coloredblock';
import useCommonProps from '../../../../../hooks/useCommonProps';
import useLocalization from "../../../../../hooks/useLocalization";
var ThemeBackground = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: 100%;\n  background: #5C97FF;\n  padding: 48px 90px 48px 48px;\n\n  color: ", ";\n  font-family: Inter;\n  font-size: 42px;\n  font-weight: 600;\n  line-height: 48px;\n  letter-spacing: -0.84px;\n"], ["\n  width: 100%;\n  background: #5C97FF;\n  padding: 48px 90px 48px 48px;\n\n  color: ", ";\n  font-family: Inter;\n  font-size: 42px;\n  font-weight: 600;\n  line-height: 48px;\n  letter-spacing: -0.84px;\n"])), Colors.geoWhite100);
export var CourseThemeBlock = function (props) {
    var post = props.post, dragHandleProps = props.dragHandleProps, isDragging = props.isDragging, isDragContinue = props.isDragContinue, isEditable = props.isEditable, linkTo = props.linkTo, colorStyle = props.colorStyle, viewType = props.viewType, hasExamBlock = props.hasExamBlock;
    var _a = useCommonProps(), courseGeneralColor = _a.courseGeneralColor, themeIndex = _a.themeIndex;
    var t = useLocalization().t;
    var hasThemeTitle = (post === null || post === void 0 ? void 0 : post.text) && post.text.trim().length > 0;
    var isExam = themeIndex === -1 || hasExamBlock;
    var themeSuffix = (typeof themeIndex === 'number' && themeIndex >= 0) ? " ".concat(themeIndex + 1) : '';
    var themeTitle = hasThemeTitle
        ? (isExam ? t('lms.exam.block_title') : "".concat(t('lms.lesson_edit.lesson_theme')).concat(themeSuffix))
        : '';
    var mainText = hasThemeTitle
        ? "".concat(post.text)
        : (isExam ? t('lms.exam.block_title') : "".concat(t('lms.lesson_edit.lesson_theme')).concat(themeSuffix));
    return (React.createElement(ColoredPost, { post: __assign(__assign({}, post), { text: mainText, color: courseGeneralColor || '#5C97FF' }), hasThemeTitle: hasThemeTitle, themeTitle: themeTitle, isCourseTheme: true, viewType: viewType }));
};
var templateObject_1;
//# sourceMappingURL=courseThemeBlock.js.mapvar __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import styled from 'styled-components';
import { Colors } from '@brg/ui';
import ColoredPost from '../coloredblock';
import useCommonProps from '../../../../../hooks/useCommonProps';
import useLocalization from "../../../../../hooks/useLocalization";
var ThemeBackground = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: 100%;\n  background: #5C97FF;\n  padding: 48px 90px 48px 48px;\n\n  color: ", ";\n  font-family: Inter;\n  font-size: 42px;\n  font-weight: 600;\n  line-height: 48px;\n  letter-spacing: -0.84px;\n"], ["\n  width: 100%;\n  background: #5C97FF;\n  padding: 48px 90px 48px 48px;\n\n  color: ", ";\n  font-family: Inter;\n  font-size: 42px;\n  font-weight: 600;\n  line-height: 48px;\n  letter-spacing: -0.84px;\n"])), Colors.geoWhite100);
export var CourseThemeBlock = function (props) {
    var post = props.post, dragHandleProps = props.dragHandleProps, isDragging = props.isDragging, isDragContinue = props.isDragContinue, isEditable = props.isEditable, linkTo = props.linkTo, colorStyle = props.colorStyle, viewType = props.viewType, hasExamBlock = props.hasExamBlock;
    var _a = useCommonProps(), courseGeneralColor = _a.courseGeneralColor, themeIndex = _a.themeIndex;
    var t = useLocalization().t;
    var hasThemeTitle = (post === null || post === void 0 ? void 0 : post.text) && post.text.trim().length > 0;
    var isExam = themeIndex === -1 || hasExamBlock;
    var themeSuffix = (typeof themeIndex === 'number' && themeIndex >= 0) ? " ".concat(themeIndex + 1) : '';
    var themeTitle = hasThemeTitle
        ? (isExam ? t('lms.exam.block_title') : "".concat(t('lms.lesson_edit.lesson_theme')).concat(themeSuffix))
        : '';
    var mainText = hasThemeTitle
        ? "".concat(post.text)
        : (isExam ? t('lms.exam.block_title') : "".concat(t('lms.lesson_edit.lesson_theme')).concat(themeSuffix));
    return (React.createElement(ColoredPost, { post: __assign(__assign({}, post), { text: mainText, color: courseGeneralColor || '#5C97FF' }), hasThemeTitle: hasThemeTitle, themeTitle: themeTitle, isCourseTheme: true, viewType: viewType }));
};
var templateObject_1;
//# sourceMappingURL=courseThemeBlock.js.map